import { render, staticRenderFns } from "./AnalysePreferenceCriteria.vue?vue&type=template&id=0badf72d&scoped=true"
import script from "./AnalysePreferenceCriteria.vue?vue&type=script&lang=js"
export * from "./AnalysePreferenceCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0badf72d",
  null
  
)

export default component.exports